<ng-container *transloco="let t">
    <span id="userMenuAction" class="sr-only">{{ triggerLabel() }}</span>
    <span id="userMenuLabel" class="sr-only">{{ user().firstName + " " + user().lastName }}</span>
    <button
        vds-icon-button
        [vdsTooltip]="triggerLabel()"
        placement="bottom"
        aria-labelledby="userMenuAction userMenuLabel"
        appearance="ghost"
        mode="dark"
        [vdsMenuTriggerFor]="userMenu"
    >
        <vds-icon name="user-new" />
    </button>

    <ng-template #userMenu>
        <vds-menu appearance="dark">
            <ng-container *featureFlag="'feature-flags-toggle'; else defaultMenu">
                <a vdsMenuItem routerLink="myaccount">
                    {{ t("myaccTextMyAccount") }}
                </a>
                <a vdsMenuItem routerLink="subscriptions">
                    {{ t("voTextViewSubscriptions") }}
                </a>
                <button type="button" vdsMenuItem (triggered)="toggleDrawer.emit()">Features</button>
                <button type="button" vdsMenuItem (triggered)="logout.emit()">
                    {{ t("voTextSIGNOUT") }}
                </button>
            </ng-container>
            <ng-template #defaultMenu>
                <a vdsMenuItem routerLink="myaccount">
                    {{ t("myaccTextMyAccount") }}
                </a>
                <a vdsMenuItem routerLink="subscriptions">
                    {{ t("voTextViewSubscriptions") }}
                </a>
                <button type="button" vdsMenuItem (triggered)="logout.emit()">
                    {{ t("voTextSIGNOUT") }}
                </button>
            </ng-template>
        </vds-menu>
    </ng-template>
</ng-container>
